// Pushes a `phone_click` event to the GTM dataLayer when a user taps a
// phone number link on a landing page. Use as the onClick handler for any
// `<a href="tel:...">` element.

export function trackPhoneClick(pageId: string, phoneNumber: string) {
  if (typeof window === "undefined") return;
  const w = window as unknown as { dataLayer?: Array<Record<string, unknown>> };
  w.dataLayer = w.dataLayer || [];
  w.dataLayer.push({
    event: "phone_click",
    page_id: pageId,
    phone_number: phoneNumber,
  });
}
